import {
  Navbar,
  Nav,
  NavItem,
  NavLink,
  Dropdown,
} from 'react-bootstrap';


function Header(props) {

  return (
    <div>
      <Navbar bg="light" expand="lg">
        <Navbar.Brand href="/admin/homepage">Home</Navbar.Brand>
        {/* <Nav className="mr-auto" navbar>
          <NavItem>
            <NavLink></NavLink>
          </NavItem>
          <Dropdown >
            <Dropdown.Toggle variant="secondary" >
              Courses Management
            </Dropdown.Toggle>
            <Dropdown.Menu align="right">
              <Dropdown.Item href='/course-creation'>
                Add/Close Courses
              </Dropdown.Item>
              <Dropdown.Item href='/parse-excel'>
                Import excel files
              </Dropdown.Item>
              <Dropdown.Item href='/vouchers'>
                Send Voucher Codes
              </Dropdown.Item>
              <Dropdown.Item divider />
            </Dropdown.Menu>
          </Dropdown>
        </Nav> */}
      </Navbar>
    </div>
  );

}

export default Header;